import { useEffect } from "react"
import { debounce } from "throttle-debounce"

export function useScreenHeight() {
  const setMinHeightFromScreen = () => {
    const nextWarapper = document.getElementById("__next")
    if (nextWarapper) {
      const viewportHeight = window.innerHeight
      nextWarapper.style.minHeight = `${viewportHeight}px`
    }
  }
  const resizeHandler = debounce(300, setMinHeightFromScreen)

  useEffect(() => {
    setMinHeightFromScreen()
    window.addEventListener("resize", resizeHandler)
    return () => window.removeEventListener("resize", resizeHandler)
  }, [resizeHandler])
}
